import React from "react";
import AdminFacilityTable from "./elements/AdminFacilityTable";
import LogoIcon from "./assets/img/logo-main.png";

export default function AdminDashboard() {
  document.title ='Admin Dashboard - Hentian Komuniti';
  console.log("Admin Dashboard");
  return (
    <div className="d-flex">
      <div className="col-12">
        <div className="mt-2 ms-4">
          <h3 className="company-name">
            <span className="">
              <img src={LogoIcon} className="me-2 logo-merchant"></img>
            </span>
            Hentian Komuniti
          </h3>
        </div>
        <hr id="line" className="text-secondary"></hr>
        <div className="ms-4">
          <i className="bi bi-buildings fs-3"></i>
          <span className="fs-5 ms-2">List of Facility</span>
        </div>
        <div className="">
          <AdminFacilityTable />
        </div>
      </div>
    </div>
  );
}
